import { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";

import { useTranslation } from "react-i18next";

const LayoutLanding = () => {

    const { t, i18n } = useTranslation();

    const location = useLocation();

    const [isScrolled, setIsScrolled] = useState(false);
    const [activeSection, setActiveSection] = useState();

    const sections = ["inicio", "nosotros", "productos", "servicios", "donde-encontrarnos"];

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    const handleScroll = () => {

        const scrollTop = window.scrollY;
        const threshold = 50;
        if (scrollTop > threshold) {
            setIsScrolled(true);
        } else {
            setIsScrolled(false);
        }

        const scrollPosition = window.scrollY + 100;

        sections.forEach((sectionId) => {
            const section = document.getElementById(sectionId);
            if (section) {
                const offsetTop = section.offsetTop;
                const sectionHeight = section.offsetHeight;

                if (scrollPosition >= offsetTop && scrollPosition < offsetTop + sectionHeight) {
                    setActiveSection(sectionId);
                }
            }
        });
    };

    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            const element = document.querySelector(hash);
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        }

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <>
            <div className="fixedArea">
                <nav className={`navbar myNavBar navbar-expand-lg ${isScrolled ? "active" : ""}`}>
                    <div className="container-fluid">
                        <Link
                            to={"/"}
                            className='navbar-header navbar-brand d-flex'
                        >
                            <img className="img-responsive logo" alt="Logo agroesana" />
                        </Link>
                        <button className="navbar-toggler border-0" type="button" data-bs-toggle="collapse" data-bs-target="#bs-example-navbar-collapse-1" aria-controls="bs-example-navbar-collapse-1" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                                <li className="navbar-landing nav-item">
                                    <Link
                                        to={"/"}
                                        className={`nav-link ${/^\/inicio(\/.*)?$/.test(location.pathname) || location.pathname === "/" ? "active" : ""} text-uppercase font-weight-bold js-scroll-trigger`}>
                                        {t("home")}
                                    </Link>
                                </li>
                                <li className="navbar-landing nav-item">
                                    <Link
                                        to={'/nosotros'}
                                        className={`nav-link ${/^\/nosotros(\/.*)?$/.test(location.pathname) ? "active" : ""} text-uppercase font-weight-bold js-scroll-trigger`}>
                                        {t("us")}
                                    </Link>
                                </li>
                                <li className="navbar-landing nav-item">
                                    <Link
                                        to={'/productos'}
                                        className={`nav-link ${/^\/productos(\/.*)?$/.test(location.pathname) ? "active" : ""} text-uppercase font-weight-bold js-scroll-trigger`}>
                                        {t("products")}
                                    </Link>
                                </li>
                                <li className="navbar-landing nav-item">
                                    <Link
                                        to={'/servicios'}
                                        className={`nav-link ${/^\/servicios(\/.*)?$/.test(location.pathname) ? "active" : ""} text-uppercase font-weight-bold js-scroll-trigger`}>
                                        {t("services")}
                                    </Link>
                                </li>
                                <li className="navbar-landing nav-item">
                                    <Link
                                        to={'/galeria'}
                                        className={`nav-link ${/^\/galeria(\/.*)?$/.test(location.pathname) ? "active" : ""} text-uppercase font-weight-bold js-scroll-trigger`}>
                                        {t("gallery")}
                                    </Link>
                                </li>
                                <li className="navbar-landing nav-item">
                                    <Link
                                        to={'/donde-encontrarnos'}
                                        className={`nav-link ${/^\/donde-encontrarnos(\/.*)?$/.test(location.pathname) ? "active" : ""} text-uppercase font-weight-bold js-scroll-trigger`}>
                                        {t("whereFindUs")}
                                    </Link>
                                </li>
                                <li className="navbar-landing nav-item align-content-center">
                                    <div className="circle">
                                        {
                                            i18n.language == "es" ? (
                                                <img
                                                    src={`/assets/img/new/eeuu.png`}
                                                    onClick={() => changeLanguage("en")}
                                                    alt="Inglish"
                                                    title="Cambiar idioma"
                                                />
                                            ) : (
                                                <img
                                                    src={`/assets/img/new/spanish.png`}
                                                    onClick={() => changeLanguage("es")}
                                                    alt="Spanish"
                                                    title="Change language"
                                                />
                                            )
                                        }

                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
            </div>
            <Outlet />
            <footer id="footer" className="footer-area section-footer mt-5" style={{ background: "#0f3d0e" }} >
                <div className="footer-widget">
                    <div className="container mt-5">
                        <div className="row py-5">
                            <div className="col-lg-8 col-md-6 d-flex justify-content-center">
                                <div className="footer-about text-center wow fadeIn" data-wow-duration="1.3s" data-wow-delay="0.2s">
                                    <a className="" href="/" >
                                        <img src="/assets/img/logo-white.png" alt="Logo agroesana" style={{ width: "100%" }} />
                                    </a>
                                    <p className="text">{t("companyDescription")}</p>
                                    <ul className="social">
                                        <li>
                                            <a className="" href="https://wa.me/+573150459980?text=Hola, quiero mas información" target="_blank">
                                                <img width={42} src={`/assets/img/new/whatsapp.svg`} />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://www.facebook.com/share/1A8APBFLgx/?mibextid=wwXIfr" target='_blank'>
                                                <img width={40} src={`/assets/img/new/facebook.svg`} />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://www.instagram.com/agroesanasas" target='_blank'>
                                                <img width={40} src={`/assets/img/new/instagram.svg`} />
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 d-flex align-items-center">
                                <div className="footer-contact mt-45 wow fadeIn" data-wow-duration="1.3s" data-wow-delay="0.8s">
                                    <ul className="contact-list mt-4">
                                        <li>
                                            <div className="contact-info">
                                                <div className="info-content media-body d-flex">
                                                    <img className="me-2" width={30} src={`/assets/img/new/ubicacion.svg`} />
                                                    <p className="text">
                                                        Calle 183 b # 8 29, Bogota D.C
                                                    </p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="contact-info mt-2 d-flex">
                                                <div className="info-content media-body d-flex">
                                                    <img className="me-2" width={30} src={`/assets/img/new/telefono.svg`} />
                                                    <p className="text">
                                                        (+57) 315 045 9980
                                                    </p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="contact-info mt-2 d-flex">
                                                <div className="info-content media-body d-flex">
                                                    <img className="me-2" width={30} src={`/assets/img/new/correo.svg`} />
                                                    <p className="text">
                                                        <i className="bi bi-facebook"></i> agroesana@gmail.com
                                                    </p>
                                                </div>
                                            </div>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="footer-copyright" style={{ background: '#ecae00' }}>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="copyright d-sm-flex justify-content-between p-2">
                                <div className="copyright-privacy text-center">
                                    <a href="https://kodevins.com" target='_blank'>
                                        <p className="text" style={{ fontSize: '17px' }}>{t("designedDeveloped")}: @kodevins</p>
                                    </a>
                                </div>

                                <div className="copyright-text text-center">
                                    <p className="text" style={{ fontSize: '17px' }}>{t("allRightsReserved")}</p>
                                </div>

                                <div className="copyright-text text-center">
                                    <p className="text" style={{ fontSize: '17px' }}>Agroesana Sas © {new Date().getFullYear()}</p>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </footer >

            <div className="chat-container">
                <div className="chat-icon">
                    <a href="https://wa.me/+573150459980?text=Hola, quiero cotizar" className="btn-wsp" target="_blank">
                        <img src={`/assets/img/new/whatsapp.svg`} />
                    </a>
                </div>
            </div>
        </>
    );
}

export default LayoutLanding